import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import { map, tap } from 'rxjs/operators';
import * as fromRoot from '@app/store/app.reducer';
import { ApiErrorLevelEnum, Notification } from 'outshared-lib';
import * as fromDocuments from '@app/my-zone/pages/claims/store/actions/documents.actions';
import { Bewijsstuk, Knop } from '@app/core/interfaces/bewijsstukken';
import * as fromClaims from '@app/my-zone/pages/claims/store/actions/claims.actions';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ins-paperwork-container',
    template: `
        <ins-paperwork
            (submitEvidence)="onSubmitEvidence($event)"
            [isLoaded]="isLoaded$ | async"
            [isLoading]="isLoading$ | async"
            [messages]="messages$ | async"
            [buttonSubmit]="buttonSubmit"
            [dossier_volgnummer]="file_serial_number"
            [relatie_id]="relation_id"
            [documentaryEvidence]="documentaryEvidence$ | async"
            [selectedButtons]="selectedButtons$ | async"
            [upload_enveloppe_volgnummer]="uploadEnveloppeVolgnummer$ | async"
        >
        </ins-paperwork>
    `
})
export class PaperworkContainer implements OnInit, OnDestroy {
    @Input() file_serial_number: number;
    @Input() relation_id: number;
    public readonly documentaryEvidence$: Observable<Bewijsstuk[]> = this.store.pipe(
        select(fromMyClaims.getSelectedBewijsstuk),
        map(b => b === undefined ? [] : b)
    );
    public readonly selectedButtons$ = this.store.pipe(select(fromMyClaims.getSelectedKnoppen));
    public readonly messages$: Observable<Notification[]> = this.store.pipe(
        select(fromMyClaims.getSelectedBewijsstukMessages),
        map((messages) => {
            if (messages && messages.length) {
                return messages.filter((item: any) => item.soort !== ApiErrorLevelEnum.Info);
            }
            return messages;
        }));
    public readonly isLoading$: Observable<boolean> = this.store.pipe(select(fromMyClaims.isDocumentsLoading));
    public readonly isLoaded$: Observable<boolean> = this.store.pipe(select(fromMyClaims.isSelectedBewijsstukkenLoaded));
    public readonly uploadEnveloppeVolgnummer$: Observable<number> = this.store.pipe(select(fromMyClaims.getSelectedUploadEnveloppeVolgnummer));
    public buttonSubmit: Knop;
    private subscription: Subscription = new Subscription();

    constructor(
        private store: Store<fromRoot.State>,
        private route: ActivatedRoute
    ) {}

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit(): void {
        const subLoaded = this.isLoaded$.subscribe(loaded => {
            if (loaded === undefined) {
                this.store.dispatch(new fromDocuments.Load({
                    dossier_volgnummer: this.file_serial_number
                }));
            }
        });

        const buttonSubscription = this.selectedButtons$.pipe(tap((selectedButtons) => {
            if (selectedButtons) {
                selectedButtons.forEach((button) => {
                    if (button.knop_naam === 'indienen_bewijsstuk') {
                        this.buttonSubmit = button;
                    }
                });
            }
        })).subscribe();

        this.subscription.add(subLoaded);
        this.subscription.add(buttonSubscription);
    }

    public onSubmitEvidence(payload): void {
        this.store.dispatch(new fromDocuments.Submit(payload));
        this.store.dispatch(new fromDocuments.Load({
            dossier_volgnummer: this.file_serial_number,
        }));
        this.subscription.add(
            this.route
                .queryParams
                .subscribe(params => this.store.dispatch(new fromClaims.LoadActions({ dossier_volgnummer: params.d }))),
        );
    }
}
